import { BaseElementWithoutShadowDOM } from '@theme/base-element'

export class ComponentCollectionTab extends BaseElementWithoutShadowDOM {
  get inputElements() {
    return (
      this.renderRoot ?? document.createDocumentFragment()
    ).querySelectorAll('.peer')
  }

  static HIDDEN_CLASSES = ['h-0', 'hidden', 'opacity-0']
  static VISIBLE_CLASSES = ['h-auto', 'visible', 'opacity-1']

  updated(changedProperties) {
    super.updated(changedProperties)
    this.inputElements?.forEach((input) => {
      input.removeEventListener('click', this.handleInputClick)
      input.addEventListener('click', this.handleInputClick.bind(this))
    })
  }

  connectedCallback() {
    super.connectedCallback()

    if (this.inputElements.length > 0) {
      const firstInput = this.inputElements[0]
      const contentId = firstInput.getAttribute('aria-controls')

      firstInput.checked = true
      const firstContentElement = this.querySelector(
        `[data-peer-content-id="${contentId}"]`
      )
      if (firstContentElement) {
        ComponentCollectionTab.HIDDEN_CLASSES.forEach((cls) =>
          firstContentElement.classList.remove(cls)
        )
        ComponentCollectionTab.VISIBLE_CLASSES.forEach((cls) =>
          firstContentElement.classList.add(cls)
        )
      }
    }
  }

  handleInputClick(event) {
    const target = event.target
    const contentId = target.getAttribute('aria-controls')
    const contentElement = this.querySelector(
      `[data-peer-content-id="${contentId}"]`
    )
    const allContentElements = this.querySelectorAll('.peer-content')

    allContentElements.forEach((content) => {
      ComponentCollectionTab.VISIBLE_CLASSES.forEach((cls) =>
        content.classList.remove(cls)
      )
      ComponentCollectionTab.HIDDEN_CLASSES.forEach((cls) =>
        content.classList.add(cls)
      )
    })

    if (contentElement) {
      if (target.checked) {
        ComponentCollectionTab.HIDDEN_CLASSES.forEach((cls) =>
          contentElement.classList.remove(cls)
        )
        ComponentCollectionTab.VISIBLE_CLASSES.forEach((cls) =>
          contentElement.classList.add(cls)
        )
      }
    }
  }
}

customElements.define('component-collection-tab', ComponentCollectionTab)
